import { NotificationRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createNotification: (
  fetchContext: FetchContext,
  notification: NotificationRequest,
  accessToken?: string,
) => Promise<number> = async (fetchContext, notification, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/notifications`,
  {
    method: 'POST',
    body: JSON.stringify(notification),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'create notification'));
